import { Paper } from '@material-ui/core'
import React from 'react'
import { PaperProps } from '@material-ui/core/Paper'
import styled from '../../../theme'

type Type = React.ComponentType<PaperProps>
const ReservationModalWrapper: Type = styled(Paper)<PaperProps>`
  width: 92vw;
  height: 85vh;
  border: none;
  outline: none;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    height: 95%;
    max-width: 100vw;
    max-height: 95%;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
`

export default ReservationModalWrapper
